import React from 'react';
import MusicAlbumAddPopup1 from './MusicAlbumAddPopup1';
import MusicAlbumAddPopup2 from './MusicAlbumAddPopup2';

export default function MusicAlbumAddPopupSequence({
  onClose,
  onGoToMusicAlbumCreate,
  onGoToMusicUpload,
  hasMusic,
} : {
  hasMusic: boolean,
  onClose: () => void,
  onGoToMusicAlbumCreate: () => void,
  onGoToMusicUpload: () => void,
}) {
  const [popup, setPopup] = React.useState<'popup1'|'popup2'>('popup1');
  return (
    <>
      {popup === 'popup1' && (
        <MusicAlbumAddPopup1
          hasMusic={hasMusic}
          onGoToMusicUpload={onGoToMusicUpload}
          onDone={() => { setPopup('popup2'); }}
          onClose={() => { onClose(); setPopup('popup1'); }}
        />
      )}
      {popup === 'popup2' && (
        <MusicAlbumAddPopup2
          onDone={() => { onGoToMusicAlbumCreate(); }}
          onClose={() => { onClose(); setPopup('popup1'); }}
        />
      )}
    </>
  );
}
